import React, { useState, useEffect } from 'react';
import '../styles/ApplyForJobs.css';

const ApplyForJobs = () => {
  const [jobs, setJobs] = useState([
    {
      id: 1,
      title: 'Senior Software Engineer',
      company: 'Tech Solutions Inc.',
      location: 'Remote',
      type: 'Full-time',
      description:
        'We are looking for a skilled Senior Software Engineer to join our dynamic team...',
      keywords: ['JavaScript', 'Python', 'React', 'Node.js', 'remote'],
    },
    {
      id: 2,
      title: 'Marketing Specialist',
      company: 'Creative Hub',
      location: 'New York, NY',
      type: 'Full-time',
      description:
        'As a Marketing Specialist, you will develop and implement marketing strategies...',
      keywords: ['Marketing', 'SEO', 'SEM', 'Social Media', 'Content Creation'],
    },
    {
      id: 3,
      title: 'Graphic Designer',
      company: 'DesignWorks',
      location: 'San Francisco, CA',
      type: 'Part-time',
      description:
        'Seeking a talented Graphic Designer to create engaging visual content...',
      keywords: [
        'Graphic Design',
        'Adobe Photoshop',
        'Illustrator',
        'UX/UI',
        'Part-time',
      ],
    },
    {
      id: 4,
      title: 'Data Analyst',
      company: 'Data Insights Ltd.',
      location: 'Remote',
      type: 'Full-time',
      description:
        'Analyze large datasets to provide actionable insights and support business decisions...',
      keywords: ['Data Analyst', 'SQL', 'Excel', 'Tableau', 'Statistics'],
    },
    {
      id: 5,
      title: 'Project Manager',
      company: 'Innovate Corp',
      location: 'Austin, TX',
      type: 'Full-time',
      description:
        'Lead and manage project teams to ensure timely delivery of high-quality projects...',
      keywords: ['Project Management', 'Agile', 'Scrum', 'Leadership'],
    },
  ]);

  const [filteredJobs, setFilteredJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    // Initialize filtered jobs with all jobs
    setFilteredJobs(jobs);
  }, [jobs]);

  useEffect(() => {
    // Filter jobs based on search term
    if (searchTerm.trim() === '') {
      setFilteredJobs(jobs);
    } else {
      const filtered = jobs.filter(
        (job) =>
          job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          job.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
          job.keywords.some((keyword) =>
            keyword.toLowerCase().includes(searchTerm.toLowerCase())
          )
      );
      setFilteredJobs(filtered);
    }
  }, [searchTerm, jobs]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleApplyClick = (jobId, e) => {
    e.preventDefault();
    // In a real application, this would navigate to an application form or open a modal
    alert(`Applying for job ID: ${jobId}`);
    console.log(`User applied for job with ID: ${jobId}`);
  };

  const handleKeyPress = (e, callback, ...args) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback(...args);
    }
  };

  return (
    <div className='job-board-container'>
      <div className='container'>
        <h1 className='job-board-title'>Available Jobs in Fahple</h1>

        <div className='search-bar'>
          <input
            type='text'
            id='searchInput'
            placeholder='Search for jobs...'
            value={searchTerm}
            onChange={handleSearchChange}
            aria-label='Search for jobs'
          />
        </div>

        <div id='job-list' className='job-list'>
          {filteredJobs.length === 0 ? (
            <p className='no-jobs-message'>
              No jobs found. Try a different search.
            </p>
          ) : (
            filteredJobs.map((job) => (
              <div key={job.id} className='job-card'>
                <h2 className='job-title'>{job.title}</h2>
                <h3 className='company-name'>{job.company}</h3>
                <div className='meta'>
                  <span className='meta-item'>
                    <strong>📍 Location:</strong> {job.location}
                  </span>
                  <span className='meta-item'>
                    <strong>⏰ Type:</strong> {job.type}
                  </span>
                </div>
                <p className='job-description'>{job.description}</p>
                <div className='keywords'>
                  {job.keywords.map((keyword, index) => (
                    <span key={index} className='keyword-tag'>
                      {keyword}
                    </span>
                  ))}
                </div>
                <button
                  className='apply-btn'
                  onClick={(e) => handleApplyClick(job.id, e)}
                  onKeyPress={(e) =>
                    handleKeyPress(e, handleApplyClick, job.id, e)
                  }
                  aria-label={`Apply for ${job.title} at ${job.company}`}
                >
                  Apply Now
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ApplyForJobs;
